<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="optional"
    :preselectFirst="preselectFirst"
    :loading="isLoading"
    :label="moduleLabel"
    :track-by="this.componentValueKey"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },

  props: {
    nameField: { type: [String, Number], default: null },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    includeAll: { type: Boolean, default: false },
    isObject: { type: Boolean, default: false },
    type: { type: String, default: 'pos' },
    partnerId: { type: String, default: null },
    customLabel: { type: String, default: 'name' },
    optional: { type: Boolean, default: false },
    preselectFirst: { type: Boolean, default: true },
    unavaliableItems: {
      type: Array,
      default: () => {
        return [];
      }
    },
    valueName: { type: String, default: null }
  },

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false,
      componentValueKey: this.valueName ? this.valueName : this.type.toLowerCase() + 'Id'
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', this.componentValueKey, null);
        return;
      }
      if (this.isObject == true) {
        this.$emit('selectChange', `${this.type.toLowerCase()}Id`, e);
        return;
      }
      this.$emit('selectChange', this.componentValueKey, e[this.componentValueKey]);
    },
    label({ name }) {
      return `${name}`;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option[`${this.type.toLowerCase()}Id`] === value);

        if (this.isObject == true) {
          this.$emit('selectChange', `${this.type.toLowerCase()}Id`, this.selected);
          return;
        }
        this.selected = this.options.find((option) => option[this.componentValueKey] === value);
      } else {
        this.selected = this.options.find((option) => option[this.componentValueKey] === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      const payload = this.partnerId ? { partnerId: this.partnerId } : null;
      this.isLoading = true;
      const commonTypes = new Set(['modality', 'acquirer', 'paymentMethod', 'activityType', 'agencyType']);
      const endpoint = commonTypes.has(this.type)
        ? `common/${this.type}/getAll`
        : `gestorLoterico/${this.type}/get`;
      this.$api
        .search(endpoint, payload)
        .then((res) => {
          const typeMap = {
            pos: 'pointsOfSale',
            product: 'products',
            modality: 'modalities',
            terminal: 'terminals',
            acquirer: 'acquirers',
            paymentMethod: 'paymentMethods',
            activityType: 'activityTypes',
            agencyType: 'agencyTypes'
          };
          const sel = typeMap[this.type] || null;

          if (this.unavaliableItems?.length) {
            this.options = res[sel].filter((i) => {
              return !this.unavaliableItems.includes(i[this.type.toLowerCase() + 'Id']);
            });
          } else {
            this.options = res[sel];
            if (this.valueName) this.options = this.personalizaChaves(res[sel]);
          }

          if (this.includeAll) {
            this.options.unshift({
              [this.componentValueKey]: null,
              [this.moduleLabel]: this.$i18n.t(this.emptyLabel)
            });
          } else if (this.optional) {
            this.options.unshift({
              [this.componentValueKey]: null,
              [this.moduleLabel]: this.$i18n.t(this.emptyLabel || 'Selecione')
            });
          }

          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro ao Carregar Dados',
            msgContent: 'Entre em contato com o Administrador do Sistema.',
            type: 'error'
          });
        });
    },
    personalizaChaves(options) {
      const regras = {
        acquirerId: this.componentValueKey,
        paymentMethodId: this.componentValueKey
      };
      return this.$util.renomearChavesEmArray(options, regras);
    }
  },
  created() {
    this.setOptions();
  },
  computed: {
    moduleLabel() {
      return this.customLabel || 'name';
    }
  },
  watch: {
    nameField: function (newVal) {
      this.setValue(newVal);
    }
  }
};
</script>
